module.exports = function() {
  return new Worker(__webpack_public_path__ + "fee53a2cf7a9f87c6e69.worker.js");
};